import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { storeNameColumn } from 'TableCommon/defaultColumns'
import { formatUnits, getNumberWithCurrency, handleNullCase } from 'utils'

import Box from '@mui/material/Box'

const TitleIcons = storeNameColumn.RowRenderer

function TableTrafficRow({ data, index, style }) {
  const { t: translate } = useTranslation()
  const { maxTraffic, showModal, stores } = data
  const store = stores[index]
  const modalHandler = () => showModal(store)
  const barWidth = Math.round((100 * store.trafficCurrent) / maxTraffic)
  const getPercentage = value => (value === null ? handleNullCase(value) : `${formatUnits(value * 100, translate)}%`)
  const conversion = getPercentage(store.conversionCurrent)

  return (
    <Box
      style={style}
      onClick={modalHandler}
      className={classNames('row cursor-pointer', { 'is-temporary-closed': store.temporaryClosed })}
    >
      <div className="row-wrapper flex-row">
        <div className="cell-bar" style={{ width: `${barWidth}%` }} />

        <div className="cell-title flex-row">
          <TitleIcons {...data} store={store} />
        </div>

        <div className="cell-category tablet-portrait-up-only">
          <span className={classNames('category', `is-${store.cluster === '-' ? 'none' : store.cluster.toLocaleLowerCase()}`)}>
            {store.cluster}
          </span>
        </div>

        <div className="cell cell-value">
          <span>
            {getNumberWithCurrency({
              currency: store.currency,
              number: store.revenueCurrent,
              precision: 0,
              translate,
            })}
          </span>
        </div>

        <div className="cell cell-traffic">
          <span>{store.trafficCurrent}</span>
        </div>

        <div className="cell cell-conversion">
          <span>{conversion}</span>
        </div>
      </div>
    </Box>
  )
}

TableTrafficRow.propTypes = {
  data: PropTypes.shape({
    maxTraffic: PropTypes.number,
    showModal: PropTypes.func,
    stores: PropTypes.arrayOf(PropTypes.object),
    trafficCurrent: PropTypes.number,
  }),
  index: PropTypes.number,
  style: PropTypes.object,
}

export default TableTrafficRow
